import cfiLogic from '../../cfiLogic';

/**
 * Parses a URL hash string and returns an object with the best available parameter to use when constructing a BookLocation.
 *
 * @method getHashParameter
 * @param {String} hashString - hash portion of a url or path string
 * @returns {Object} object containing, at most, one named parameter
 */
const getHashParameter = (hashString) => {
  // When URL is path#cfi?params, hash contains "?" — use only the part before "?" for CFI.
  const hashForCfi =
    hashString && hashString.includes('?')
      ? hashString.slice(0, hashString.indexOf('?'))
      : hashString;

  // Use CFI if available
  // If we are navigating by CFI, the hash value will start with a /
  let cfi = hashForCfi.match(/^#(\/.*)/)?.[1];
  cfi = cfi && cfiLogic.isValidCfi(cfi) ? cfi : undefined;

  if (cfi) {
    return { cfi };
  }

  // If a CFI is not available, see if the hash contains an element id instead
  // In this case, the hash will start with an additional #
  const element = hashForCfi.match(/^##(.*)/)?.[1];

  if (element) {
    return { element };
  }

  // Last, try to parse a percentage from the URL
  // A percentage will be a floating point number from 0.0% to 100.0%, including the sign
  let percentageOfDocument = hashForCfi.match(/^#(\d+(?:\.\d+)?)%$/)?.[1];
  percentageOfDocument = percentageOfDocument
    ? parseFloat(percentageOfDocument) / 100
    : undefined;

  if (percentageOfDocument !== undefined) {
    return { percentageOfDocument };
  }

  // If a word offset is present
  // the structure from the url will start with '#word'
  const wordOffset = hashForCfi.match(/^#word(\d+)-(\d+)/);
  if (wordOffset) {
    return { wordOffset: [wordOffset[1], wordOffset[2]] };
  }

  return {};
};

export default getHashParameter;
